import { useMutation, useQuery } from "urql";

const GET_HABERES_VARIABLES_COMMENTS = `
  query GET_HABERES_VARIABLES_COMMENTS($companyId: String!, $period: String!) {
    getHaberesVariablesComments(companyId: $companyId, period: $period) {
      user {
        id
        name
        email
      }
      date
      comment
    }
  }
`;

export const GetHaberesVariablesComments = ({ companyId, period, pause = true }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_HABERES_VARIABLES_COMMENTS,
    variables: { companyId, period },
    pause: pause || !companyId || !period,
    requestPolicy: "network-only",
  });
  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    reexecuteQuery: () => reexecuteQuery({ requestPolicy: "network-only" }),
  };
};

const CREATE_HABERES_VARIABLES_COMMENT = `
  mutation CREATE_HABERES_VARIABLES_COMMENT(
    $companyId: String!
    $period: String!
    $comment: String!
  ) {
    createHaberesVariablesComment(
      input: {
        companyId: $companyId
        period: $period
        comment: $comment
      }
    ) {
      id
      period
      innerComments {
        user {
          id
          name
          email
        }
        date
        comment
      }
    }
  }
`;

export const CreateHaberesVariablesComment = () => {
  const [result, executeMutation] = useMutation(CREATE_HABERES_VARIABLES_COMMENT);
  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    executeMutation: (variables) => executeMutation(variables),
  };
};
